module.exports = __webpack_public_path__ + "img/rc.692ef943.svg";